<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 20 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.553 8.954 17.4 2.5h-1.389L10.93 8.07 6.82 2.5H2.5l6.133 8.929L2.5 17.5h1.389l5.363-6.234L13.69 17.5H18l-6.447-8.546Zm-1.899 2.207-.622-.89-4.944-7.072H6.17l3.993 5.71.621.89 5.19 7.423h-2.083l-4.237-6.061Z" />
  </svg>
</template>
